import { render, staticRenderFns } from "./ConfiguracaoPedido.vue?vue&type=template&id=2e5bfd56"
import script from "./ConfiguracaoPedido.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports